<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-x-lg-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <div class="footer__copyright" v-html="$t('footer.copyright')"></div>
        </div>
        <div class="col-x-lg-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <router-link :to="'/' + $i18n.locale + '/'" class="footer__logo">
            <img src="~@/assets/img/global/logo.svg" alt="" />
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss">
.footer {
  .container {
    padding: 29px 15px 27px;
    border-top: 1px solid #202020;
  }
  &__copyright {
    font-size: 20px;
    line-height: 26px;
  }
  &__logo {
    display: block;
    text-align: right;
    img {
      max-width: 170px;
    }
  }
}
@media only screen and (max-width: 1199px) {
  .footer {
    &__copyright {
      font-size: 16px;
      line-height: 22px;
    }
    &__logo {
      img {
        max-width: 100px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .footer {
    &__copyright {
      font-size: 12px;
      line-height: 15px;
    }
  }
}
@media only screen and (max-width: 375px) {
  .footer {
    &__logo {
      img {
        max-width: 90px;
      }
    }
  }
}
</style>
